require('./components/vue-declarator');

let quotazioni = document.getElementById('quotazioni');

if (quotazioni) {
	new Vue({ el: quotazioni });
}



// WEBPACK FOOTER //
// ./resources/js/app/main.js